
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-polices",
      function () {
        return require("private-next-pages/privacy-polices/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-polices"])
      });
    }
  